export const cloudManagerPaths = {
  computeLinks: '/cloud-manager/compute-links',
  sizingCatalog: '/compute/sizing-catalog',
  sizingCatalogVersions: '/compute/sizing-catalog/versions',
  sizingCatalogVersion: (version) => `/compute/sizing-catalog/${version}`,
  requests: '/cloud-manager/requests',
  agentBundles: '/cloud-manager/agent-bundles',
};
